import axiosInstance from '@/utils/api.js'

var state = {
  radiusAttr: [],
  radiusAttrAccounts: [],
  radiusAttrISGprofile: [],
  radiusAttrISGcoa: [],
  radiusAttrISGsir: [],
  radiusAttrServices: [],
  rediusAttrIPslink: []
}

var getters = {
  RADIUS_ATTR: (state) => {
    return state.radiusAttr
  },
  RADIUS_ATTR_ACCOUNTS: (state) => {
    return state.radiusAttrAccounts
  },
  RADIUS_ATTR_ISG_PROFILE: (state) => {
    return state.radiusAttrISGprofile
  },
  RADIUS_ATTR_ISG_COA: (state) => {
    return state.radiusAttrISGcoa
  },
  RADIUS_ATTR_ISG_SIR: (state) => {
    return state.radiusAttrISGsir
  },
  RADIUS_ATTR_SERVICES: (state) => {
    return state.radiusAttrServices
  },
  RADIUS_ATTR_SLINK: (state) => {
    return state.rediusAttrIPslink
  }
}

var mutations = {
  SET_RADIUS_ATTR: (state, payload) => {
    state.radiusAttr = payload
  },
  SET_RADIUS_ATTR_ACCOUNTS: (state, payload) => {
    state.radiusAttrAccounts = payload
  },
  SET_RADIUS_ATTR_ISG_PROFILE: (state, payload) => {
    state.radiusAttrISGprofile = payload
  },
  SET_RADIUS_ATTR_ISG_COA: (state, payload) => {
    state.radiusAttrISGcoa = payload
  },
  SET_RADIUS_ATTR_ISG_SIR: (state, payload) => {
    state.radiusAttrISGsir = payload
  },
  SET_RADIUS_ATTR_SERVICES: (state, payload) => {
    state.radiusAttrServices = payload
  },
  SET_RADIUS_ATTR_SLINK: (state, payload) => {
    state.rediusAttrIPslink = payload
  }
}

var actions = {
  GET_RADIUS_ATTR_NAS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=0')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR', result.data)
    }
  },
  GET_RADIUS_ATTR_ACCOUNTS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=12')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ACCOUNTS', result.data)
    }
  },
  GET_RADIUS_ATTR_ISG_PROFILE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=7')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_PROFILE', result.data)
    }
  },
  GET_RADIUS_ATTR_ISG_COA: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=8')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_COA', result.data)
    }
  },
  GET_RADIUS_ATTR_ISG_SIR: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=9')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_SIR', result.data)
    }
  },
  GET_COA_RADIUS_ATTR_ISG_SIR: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload.object_id + '&object_type=' + payload.object_type)
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_SIR', result.data)
    }
  },
  GET_RADIUS_ATTR_SERVICES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload.service_id + '&object_type=' + payload.service_type)
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_SERVICES', result.data)
    }
  },
  GET_RADIUS_ATTR_SLINK: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload.slink_id + '&object_type=10000')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_SLINK', result.data)
    }
  },
  UPDATE_RADIUS_ATTR: (context, payload) => {
    return axiosInstance.put('/tariffing/radius_attrs', payload)
  },
  REWRITE_RADIUS_ATTR: (context, payload) => {
    return axiosInstance.put('/tariffing/radius_attrs_rewrite', payload)
  },
  DELETE_RADIUS_SESSION: (context, payload) => {
    return axiosInstance.delete('/additional/radius_session?slink_id=' + payload)
  },
  DELETE_RADIUS_ATTR: (context, payload) => {
    return axiosInstance.delete('/tariffing/radius_attrs?object_type=' + payload.object_type + '&object_id=' + payload.object_id + '&radius_attr_id=' + payload.radius_attr_id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/radiusAttr.js